// Registered Temporal workflow type names for execute_workflow_by_name.
// Sourced from the SafetyCulture/temporal-workflows repo, internal/workers/support_workflows.go
// (RegisterSupportScriptWorkflows, RegisterDataGovernanceWorkflows, RegisterLifecycleWorkflows,
// RegisterEnvCreationWorkflows, RegisterContentLibraryWorkflows) — the same set is registered by
// both self-hosted and cloud governance workers, so this list applies across governance client
// types (subscriptions workflows now run exclusively on Temporal Cloud).
// Update manually if new workflows are registered there.
export const TEMPORAL_WORKFLOW_NAMES = [
  "AlexandriaCopyWorkflow",
  "AlexandriaMappingWorkflow",
  "ArchiveAlexandriaDocuments",
  "ArchiveDocumentByOwner",
  "ArchiveDuplicateSystemFieldsWorkflow",
  "Auth0Backup",
  "BackfillTemplatesItemsLabelProjection",
  "BackfillTemplatesItemsLabelProjectionStarter",
  "BlockOrganisation",
  "BulkAddUsersToGroups",
  "BulkAssignPermissionSetsWorkflow",
  "BulkBackupDocumentsToS3",
  "BulkChangeEmailAddress",
  "BulkChangeEmailSingleBatch",
  "BulkCleanupChargifySubscription",
  "BulkCopyTemplatePermissionAndAutoShare",
  "BulkCreateActions",
  "BulkCreateActionsWithConcurrency",
  "BulkCreateAssetReadings",
  "BulkCreateAssetReadingsWithConcurrency",
  "BulkCreateAssets",
  "BulkCreateAssetTypes",
  "BulkCreateAssetTypesAndData",
  "BulkCreateDemoOrgData",
  "BulkCreateIssues",
  "BulkCreateOrgs",
  "BulkCreateUsers",
  "BulkCSVWorkflowDispatcher",
  "BulkDeactivateUsers",
  "BulkDeactivateUsersAcrossOrgs",
  "BulkDeleteMediaForCPR",
  "BulkDeleteUserWorkflow",
  "BulkFetchOrgTenancy",
  "BulkForceUserLogout",
  "BulkMigrateOrgsToZuora",
  "BulkMigrateTemplates",
  "BulkMigrateToZuora",
  "BulkMoveGRS",
  "BulkOrgDeletion",
  "BulkPatchUserRoles",
  "BulkProvisionAiCredits",
  "BulkProvisionAiCreditsAcrossWindows",
  "BulkRefreshInspectionProjections",
  "BulkRemoveOrgUsersFromBounceList",
  "BulkResetOrgTemplatesAccess",
  "BulkRestoreDeletedInspections",
  "BulkRestoreInspections",
  "BulkRestoreInspectionsFromS3",
  "BulkRestoreInspectionsProcessInspections",
  "BulkRestoreScheduleStatus",
  "BulkSetInspectionAccess",
  "BulkSetSeatMovementRestrictionsWorkflow",
  "BulkSetZuoraMigrationStatus",
  "BulkStartInspections",
  "BulkSyncBillingAdminContacts",
  "BulkSyncSubscriptionsWithZuora",
  "BulkSyncSubscriptionsWithZuoraWindow",
  "BulkTransferUsers",
  "BulkTransferUsersSingleBatch",
  "BulkUpdateContext",
  "BulkUpdateContextProcessInspections",
  "BulkUpdateContextProcessTemplates",
  "BulkUpdateIdentity",
  "BulkUpdateIdentitySingleBatch",
  "BulkUpdateInspectionSite",
  "BulkUpdateInspectionTitle",
  "BulkUpdateInspectionTitleProcessInspections",
  "BulkUpdateIssueSite",
  "CleanupOrphanSoterUsersWorkflow",
  "CloneDocument",
  "CloneOrganisation",
  "CloneSubscriptions",
  "CollateSQSWorkerErrorLogs",
  "ContentLibraryAlgoliaReindex",
  "ContentLibraryBulkTestOrgDeletion",
  "ContentLibraryBulkUpdateProductImages",
  "ContentLibraryPublisherReindex",
  "ContentLibraryThumbnailBackfill",
  "CopyAnalyticsActions",
  "CopyAnalyticsInspections",
  "CopyAnalyticsIssues",
  "CopyAnalyticsSites",
  "CopyDomainDataWorkflow",
  "CopyOrganisation",
  "CopyPermissionSets",
  "CopyPrivileges",
  "CopyTraining",
  "CreateOrg",
  "DeactivateOrgSubscriptionState",
  "DeleteAnalyticsActions",
  "DeleteAnalyticsInspections",
  "DeleteAnalyticsIssues",
  "DeleteAnalyticsSites",
  "DeleteDataGovernanceQueues",
  "DeleteDomainDataWorkflow",
  "DeleteOrganisationDocument",
  "DeleteUserForIM1989",
  "DowngradeOrgDeactivateUsers",
  "GenerateDomainDataDelta",
  "MapAnalyticsActions",
  "MapAnalyticsInspections",
  "MapAnalyticsIssues",
  "MapAnalyticsSites",
  "MapDomainDataWorkflow",
  "MapPrivileges",
  "MigrateInspectionQuota",
  "MigrateToZuoraSingleOrg",
  "OrgDataClone",
  "OrgDataCopy",
  "OrgDataDeletion",
  "OrgDataMap",
  "OrgDeletion",
  "OrgMapOnly",
  "OrgMigration",
  "ProcessUpdateInspectionSiteByUserID",
  "ProvisionAiCreditsWorkflow",
  "ProvisionSCCareOrg",
  "ProvisionSupportUser",
  "PurgeDataGovernanceQueue",
  "ReactivateOrg",
  "ReactivateOrgSubscriptionState",
  "RemediateTemplatesAccess",
  "ResetOrgTemplatesAccess",
  "ResetTemplatesAccess",
  "SoterCopyWorkflow",
  "SoterMappingWorkflow",
  "SSOKeycloakEnvCreation",
  "SyncOrgBillingAdminContactsWorkflow",
  "SyncProductCatalogToAPISubscriptions",
  "TransferUser",
  "TransferUserForIM1989",
] as const;
